const handleTree = (data: any, id: any, parentId: any, children?: any, rootId?: any) => {
  id = id || "id";
  parentId = parentId || "parentId";
  children = children || "children";
  rootId =
    rootId ||
    Math.min.apply(
      Math,
      data.map((item: any) => {
        return item[parentId];
      })
    ) || 0;
  //对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data));
  //循环所有项
  const treeData = cloneData.filter((father: any) => {
    let branchArr = cloneData.filter((child: any) => {
      //返回每一项的子级数组
      return father[id] === child[parentId];
    });
    branchArr.length > 0 ? (father.children = branchArr) : (father.children = null);
    //返回第一层
    return father[parentId] == rootId;
  });
  return treeData != "" ? treeData : data;
};

const downloadFile = (url: string, filename?: string) => {
  if (!url) return;
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  if(url.includes('.pdf')){
    link.target = '_blank'
  }
  link.setAttribute("download", filename || url);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export { handleTree, downloadFile };
